import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/auth";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Experiences from "@/pages/Experiences";
import ExperienceDetail from "@/pages/ExperienceDetail";
import Boat from "@/pages/Boat";
import Taste from "@/pages/Taste";
import Stay from "@/pages/Stay";
import CreateExperience from "@/pages/CreateExperience";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import DayBuilder from "@/pages/DayBuilder";
import Contact from "@/pages/Contact";
import Companion from "@/pages/Companion";
import Gallery from "@/pages/Gallery";
import Login from "@/pages/Login";
import Legal from "@/pages/Legal";
import Faq from "@/pages/Faq";
import CookieConsent from "@/components/CookieConsent";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen flex flex-col bg-ivory">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/experiences/:slug" element={<ExperienceDetail />} />
          <Route path="/boat" element={<Boat />} />
          <Route path="/taste" element={<Taste />} />
          <Route path="/stay" element={<Stay />} />
          <Route path="/create" element={<CreateExperience />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/day-builder" element={<DayBuilder />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/companion" element={<Companion />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/login" element={<Login />} />
          <Route path="/companion/:slug" element={<Companion />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <AppRouter />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
